// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wg","heading":"xg","items":"yg","featureCss":"zg","disabled":"Ag","imgCss":"Bg"};